import {
  isUiLocale,
  LOCALE_COOKIE_MAX_AGE_SECONDS,
  LOCALE_COOKIE_NAME,
  type UiLocale,
} from "@/i18n/locale";

export function getLocaleCookie(): UiLocale | undefined {
  if (typeof document === "undefined") {
    return undefined;
  }

  const match = document.cookie
    .split("; ")
    .find((entry) => entry.startsWith(`${LOCALE_COOKIE_NAME}=`));

  if (!match) {
    return undefined;
  }

  const value = decodeURIComponent(match.split("=")[1] ?? "");
  return isUiLocale(value) ? value : undefined;
}

export function setLocaleCookie(locale: UiLocale): void {
  if (typeof document === "undefined") {
    return;
  }

  document.cookie = `${LOCALE_COOKIE_NAME}=${encodeURIComponent(locale)};path=/;max-age=${LOCALE_COOKIE_MAX_AGE_SECONDS};SameSite=Lax`;
}

export function clearLocaleCookie(): void {
  if (typeof document === "undefined") {
    return;
  }

  document.cookie = `${LOCALE_COOKIE_NAME}=;path=/;max-age=0;SameSite=Lax`;
}
